<template>
  <div class="product-modal__root">
    <div class="product-modal__img">
      <NuxtImg
        placeholder
        fit="default"
        border="default"
        loading="lazy"
        width="100px"
        height="100px"
        :src="String(product?.imageId)"
      />
    </div>
    <div class="info">
      <div class="name">{{ product.name }}</div>

      <div class="reviews__info">
        <img src="~/assets/img/svg/common/star.svg" alt="" />
        {{ reviewsRating }}
        <span class="--count">{{ reviewsCount }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IProduct } from '#sitis/internal/controllers/products/models/Product';
import { computed } from 'vue';

const props = defineProps<{
	product: IProduct;
}>();
const { $numberFormat, $handleWordDeclension } = useNuxtApp();
const reviewsCount = computed(() => {
  const count = props?.product?.reviewsCount || 0;
  const word = $handleWordDeclension(count, ['отзыв', 'отзыва', 'отзывов']);
  return [count, word].join(' ');
});

const reviewsRating = computed(() => $numberFormat((props?.product?.reviewsRating || 0), 1, '.'));
</script>

<style scoped lang="scss">
.product-modal__root {
	margin-bottom: 32px;
	display: flex;
	gap: 24px;
	padding: 32px 0;
	position: relative;
	border-top: 1px solid var(--gray);
	border-bottom: 1px solid var(--gray);

	& .info {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 8px 0;

		& .name {
			font-size: 20px;
			font-style: normal;
			font-weight: 600;
			line-height: 120%; /* 24px */
		}
	}

	& .reviews__info {
		display: flex;
		align-items: center;

		color: #989898;
		font-size: 12px;
		font-weight: 500;
		line-height: 100%;

		& img {
			width: 13px;
			height: 13px;
			margin-right: 6px;
			transform: initial !important;
		}

		& .--count {
			margin-left: 8px;
			margin-bottom: -2px;
			border-bottom: 1px solid;
			color: rgb(152 152 152 / 100%);
		}
	}
}

.product-modal__img {
	width: 100px;
	height: 100px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: hidden;
	background: var(--gray);
	border-radius: 10px;

	& > img {
		width: 100%;
		height: 100%;
		object-fit: contain;
		mix-blend-mode: darken;
		transition: all 0.3s;
	}

	&:hover img {
		transform: scale(1.1);
	}
}

@media (max-width: 860px) {
	.product-modal__root {
		margin-bottom: 24px;
		padding: 16px 0;
	}
}
</style>
